import { Capacitor } from "@capacitor/core";

export const initCapacitorPlugins = async (): Promise<void> => {
  if (!Capacitor.isNativePlatform()) return;

  // Status bar appearance is configured natively in MainActivity.java.
  // Splash screen is rendered as an HTML overlay in index.html so it sits
  // inside the WebView (which is already inset below the status bar) instead
  // of via the @capacitor/splash-screen plugin, whose native window flags
  // cover the system bars on Android 15.

  const { CapacitorUpdater } = await import("@capgo/capacitor-updater");
  await CapacitorUpdater.notifyAppReady();
};
